import React from 'react';

const NotFound = () => {
  return (
    <>
      <div className="container">
        <div className="error-text">
          <h1 className="not-found">Not Found</h1>
        </div>
      </div>
    </>
  );
};
export default NotFound;
